import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Anonymous from './Anonymous';
import AnonymousSecondary from './AnonymousSecondary';
import AuthedFull from './AuthedFull';
import AuthedTemporary from './AuthedTemporary';

import { ERROR_TYPES } from '../Slate';

const mapStateToProps = ({ tve, video }) => ({
  authenticated: tve.authenticated,
  hasTempPass: tve.hasTempPass,
  videoError: video.error,
});

function CallToAction(props) {
  const {
    authenticated,
    videoError,
    hasTempPass,
  } = props;

  if (videoError === ERROR_TYPES.BROWSER) {
    return null;
  }

  if (authenticated && !hasTempPass) {
    return <AuthedFull />;
  }

  return (
    <>
      {authenticated === true && hasTempPass && (
        <AuthedTemporary />
      )}
      {authenticated === false && (
        <Anonymous />
      )}
      <AnonymousSecondary />
    </>
  );
}

CallToAction.propTypes = {
  authenticated: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  hasTempPass: PropTypes.bool,
  videoError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
};

CallToAction.defaultProps = {
  authenticated: null,
  hasTempPass: false,
  videoError: false,
};

export default connect(mapStateToProps)(CallToAction);
